import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import ProductsService from "../services/ProductsService";
import banner from "../assets/banner.jpeg";
export default function Home() {
  const [products, setProducts] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    ProductsService.getProducts({ category: "", page: 1 }).then((res) => {
      setProducts(res.data || []);
    }).catch((err) => {
      console.error("Failed to fetch products:", err);
    }).finally(()=>setIsLoading(false));
  }, []);
  return (
    <>
      <img src={banner} width={500} className="m-auto" alt="New Hoodies winter Offer" />
      <div className="text-xl text-center dark:text-white font-bold uppercase mt-8">
        DROP II
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mx-5 my-5">
        {isLoading && products.length === 0 ? (
          Array(8).fill(null).map((_, i) => (
            <div key={i} className="col-span-1 flex flex-col items-center bg-gray-200 dark:bg-gray-700 rounded-lg shadow-md overflow-hidden w-full animate-pulse">
              <div className="w-full h-48 bg-gray-300 dark:bg-gray-600" />
              <div className="w-full px-4 py-2 dark:bg-gray-600">
              <div className="h-4 bg-gray-400 dark:bg-gray-500 rounded w-3/4 mb-2" />
              <div className="h-4 bg-gray-400 dark:bg-gray-500 rounded w-1/2 mx-auto" />
              </div>
            </div>
          ))
        ) : products.length > 0 ? (
          products.map((product) => (
            <Link key={product._id} to={`/products/${product.itemId}`} className="flex flex-col group">
              <div className="w-full aspect-[3/4] overflow-hidden shadow-md relative">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute top-[80%] left-0 bg-red-700 text-white px-2 py-1 rounded-r-xl text-xs sm:text-sm md:text-md lg:text-lg xl:text-xl">Save {product.actualPrice > 0 ? Math.round(((product.actualPrice - product.price) / product.actualPrice) * 100) : 0}%</div>
              </div>
              <div className="pt-2 text-center font-semibold text-black dark:text-white truncate">
                {product.name}
              </div>
              <div className="flex flex-row gap-5 justify-center">
                <p className="text-sm line-through font-bold">₹ {product.actualPrice}</p>
                <p className="text-sm font-bold">₹ {product.price}</p>
              </div>
            </Link>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-600 dark:text-gray-300 py-10">
            Comming Soon
          </div>
        )}
      </div>
    </>
  );
}
